export default __webpack_public_path__ + "static/expert-3-e0950b3d7cc44d5766049d4780729d3b.jpg";